import CityPageTemplate from "../city-template/CityPageTemplate";
import { lewistonConfig } from "./data";

export default function LewistonPage() {
  return <CityPageTemplate config={lewistonConfig} />;
}